const OrdenEstadoEnum = {
    CREADO: {
        id: 1
    },
    APROBADO: {
        id: 2
    },
    EMITIDO: {
        id: 3
    },
    PAGADO: {
        id: 4
    },
    RECEPCIONADO: {
        id: 5
    },
    FABRICA: {
        id: 6
    },
    PUERTO_ORIGEN: {
        id: 7
    },
    TRANSITO: {
        id: 8
    },
    PUERTO_DESTINO: {
        id: 9
    },
    ALMACEN_ADUANA: {
        id: 10
    },
    ANULADO: {
        id: 11
    },
    RECEPCIONADO_PARCIAL: {
        id: 12
    },
    PAGO_PARCIAL: {
        id: 13
    }
}

export default OrdenEstadoEnum